import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getRemoteParticipants, isLocalParticipantModerator } from '../../../base/participants/functions';
import { BUTTON_TYPES } from '../../../base/ui/constants.web';
import { isInBreakoutRoom } from '../../../breakout-rooms/functions';
import { PAGE_AUTH } from '../../../../../modules/API/constants_ts';
import { disconnect } from '../../../base/connection/actions.any';
import { kickParticipant } from '../../../base/participants';
import { getValidFeedback, sendNotificationToLobby } from '../../../base/util/functions';
import { COMMANDS } from '../../../mod-command/constants';
import { sendCommand } from '../../../mod-command/slice';
import { HangupContextMenuItem } from './HangupContextMenuItem';
import { openDialog } from '../../../base/dialog/actions';
import ConfirmDialog from '../../../base/dialog/components/web/ConfirmDialog';
import { LOBBY_TYPE_NOTI } from '../../../lobby/constants';
import { endConference } from '../../../base/conference/actions.any';
/**
 * Button to end the conference for all participants.
 *
 * @param {Object} props - Component's props.
 * @returns {JSX.Element} - The end conference button.
 */
export const EndConferenceButton = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const _isLocalParticipantModerator = useSelector(isLocalParticipantModerator);
    const _isInBreakoutRoom = useSelector(isInBreakoutRoom);
    const validFeedback = useSelector(getValidFeedback);
    const participants = useSelector((state) => Array.from(getRemoteParticipants(state).values()));
    const state = useSelector((state) => state);
    const onEndConference = useCallback(() => {
        dispatch(openDialog(ConfirmDialog, {
            hideTooltip: true,
            titleKey: 'dialog.endRoom.title',
            onSubmit: () => handleEndConference(),
            children: React.createElement("p", null, t('dialog.endRoom.content')),
            ok: {
                translationKey: 'dialog.endRoom.title'
            }
        }));
    }, [dispatch]);
    const handleEndConference = () => {
        if (_isLocalParticipantModerator) {
            if (validFeedback) {
                sendNotificationToLobby(state, dispatch, LOBBY_TYPE_NOTI.ROOM_ENDED);
                dispatch(sendCommand(COMMANDS.ROOM.COMMAND, '', true)); // anhnt653 - feedback
            }
            else {
                participants?.forEach(participant => {
                    dispatch(kickParticipant(participant.id));
                });
                setTimeout(() => {
                    dispatch(disconnect(true));
                    window.location.href = PAGE_AUTH;
                }, 500);
            }
            dispatch(endConference());
        }
    };
    return (React.createElement(React.Fragment, null, !_isInBreakoutRoom && _isLocalParticipantModerator && React.createElement(HangupContextMenuItem, { accessibilityLabel: t('toolbar.accessibilityLabel.endConference'), buttonKey: props.buttonKey, buttonType: BUTTON_TYPES.DESTRUCTIVE, label: t('toolbar.endConference'), notifyMode: props.notifyMode, onClick: onEndConference })));
};
